"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilterForSlider = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _hooks = require("@nicbase/hooks");

var _classnames = _interopRequireDefault(require("classnames"));

var _sliderModule = _interopRequireDefault(require("./slider.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var parseStringToValidNumber = function parseStringToValidNumber(dirtyString) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var regex = /^(^-)([^\d])/g;

  if (Number.isInteger(dirtyString)) {
    return dirtyString;
  }

  if (dirtyString) {
    var result = parseInt(dirtyString.replace(regex, ''), 10);

    if (Number.isInteger(result)) {
      return result;
    }
  }

  return min;
};

var useFilterForSlider = function useFilterForSlider(_ref) {
  var filters = _ref.filters,
      key = _ref.key,
      max = _ref.max,
      _ref$initialMax = _ref.initialMax,
      initialMax = _ref$initialMax === void 0 ? max : _ref$initialMax,
      _ref$initialMin = _ref.initialMin,
      initialMin = _ref$initialMin === void 0 ? 0 : _ref$initialMin;
  var filter = (0, _react.useMemo)(function () {
    var _filters$values$key, _filters$values;

    return (_filters$values$key = (_filters$values = filters.values) === null || _filters$values === void 0 ? void 0 : _filters$values[key]) !== null && _filters$values$key !== void 0 ? _filters$values$key : {
      minValue: initialMin,
      maxValue: initialMax
    };
  }, [filters.values, key, initialMin, initialMax]);
  var update = (0, _react.useCallback)(function (_ref2) {
    var _ref2$minValue = _ref2.minValue,
        minValue = _ref2$minValue === void 0 ? filter.minValue : _ref2$minValue,
        _ref2$maxValue = _ref2.maxValue,
        maxValue = _ref2$maxValue === void 0 ? filter.maxValue : _ref2$maxValue;
    return filters.update(_defineProperty({}, key, {
      minValue: minValue,
      maxValue: maxValue
    }));
  }, [filter.maxValue, filter.minValue, filters, key]);

  var _useState = (0, _react.useState)(filter.maxValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(filter.maxValue),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var debouncedValue = (0, _hooks.useDebounce)(value, 400);
  var prevValue = (0, _hooks.usePrevious)(debouncedValue);
  (0, _hooks.useDidUpdate)(function () {
    if (prevValue !== debouncedValue) {
      update({
        minValue: initialMin,
        maxValue: debouncedValue
      });
    }
  }, [prevValue, debouncedValue, update, initialMin]);
  var onSliderChange = (0, _react.useCallback)(function (_ref3) {
    var newValue = _ref3.value;
    setValue(newValue);
    setInputValue(newValue);
  }, []);
  var onInputConfirm = (0, _react.useCallback)(function () {
    onSliderChange({
      value: parseStringToValidNumber(inputValue, initialMin)
    });
  }, [initialMin, inputValue, onSliderChange]);
  var onReset = (0, _react.useCallback)(function () {
    setValue(initialMax);
    setInputValue(initialMax);
  }, [initialMax]);
  return {
    value: value,
    inputValue: inputValue,
    debouncedValue: debouncedValue,
    setInputValue: setInputValue,
    onSliderChange: onSliderChange,
    onInputConfirm: onInputConfirm,
    onReset: onReset
  };
};

exports.useFilterForSlider = useFilterForSlider;

var Slider = function Slider(_ref4) {
  var disabled = _ref4.disabled,
      className = _ref4.className,
      minValue = _ref4.minValue,
      maxValue = _ref4.maxValue,
      value = _ref4.value,
      step = _ref4.step,
      label = _ref4.label,
      _onChange = _ref4.onChange;
  return /*#__PURE__*/_react["default"].createElement("input", {
    disabled: disabled,
    className: (0, _classnames["default"])(_sliderModule["default"].slider, 'w-full h-3 bg-gray-300 outline-none rounded', className),
    style: {
      backgroundImage: "linear-gradient(90deg, #004864 ".concat(value / maxValue * 100, "%, transparent ").concat(value / maxValue * 100, "%)")
    },
    type: "range",
    min: minValue,
    max: maxValue,
    step: step,
    value: value,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    },
    "aria-label": label
  });
};

Slider.defaultProps = {
  label: 'common',
  disabled: false,
  className: '',
  step: 1,
  minValue: 0,
  value: 0,
  maxValue: 30,
  onChange: function onChange() {}
};
var _default = Slider;
exports["default"] = _default;